(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* BEGIN TFX_COLLECTION_RELATED_PRESENTATION_JS
   Objective: reuse related-products overlay add-to-cart behavior on collection product cards
   Scope: sections/main-collection.liquid (elements marked [data-tfx-collection-overlay-root])
   Rollback: remove this BEGIN/END block + TFX_COLLECTION_RELATED_PRESENTATION hooks in this section
*/
var tfxCollectionOverlayInit = function(sectionElement) {
  if (sectionElement === null) { return; }
  if (sectionElement.dataset.tfxCollectionOverlayInit === 'true') { return; }
  sectionElement.dataset.tfxCollectionOverlayInit = 'true';

  sectionElement.addEventListener('click', function(event) {
    var addButton = event.target.closest('[data-tfx-rp-add]');
    if (!addButton || !sectionElement.contains(addButton)) { return; }

    var overlayRoot = addButton.closest('[data-tfx-collection-overlay-root]');
    if (!overlayRoot || !sectionElement.contains(overlayRoot)) { return; }

    if (typeof window.tfxOverlayAddToCart !== 'function') {
      var productBlock = addButton.closest('.product-block');
      var productLink = productBlock ? productBlock.querySelector('.product-link[href]') : null;
      if (productLink) {
        window.location.href = productLink.getAttribute('href');
      }
      return;
    }

    event.preventDefault();
    window.tfxOverlayAddToCart(addButton);
  });
};

/* BEGIN TFX_COLLECTION_RELATED_MOBILE_CLICK_PRIORITY_JS
   Objective: keep mobile interaction click-first on collection cards with secondary image
   Scope: sections/main-collection.liquid only
   Rollback: remove this BEGIN/END block (CSS block can stay)
*/
var tfxBindCollectionMobileClickPriority = function(sectionElement) {
  if (sectionElement === null) { return; }
  if (sectionElement.dataset.tfxCollectionMobileClickPriorityBound === 'true') { return; }
  var narrowViewportQuery = window.matchMedia('(max-width: 959.98px)');

  var stopSwipeOnNarrow = function(event) {
    if (!narrowViewportQuery.matches) { return; }

    var imageContainer = event.target.closest('.image-cont--with-secondary-image');
    if (!imageContainer || !sectionElement.contains(imageContainer)) { return; }
    if (!imageContainer.closest('[data-tfx-collection-overlay-root]')) { return; }

    event.stopPropagation();
  };

  sectionElement.addEventListener('touchstart', stopSwipeOnNarrow, { capture: true, passive: true });
  sectionElement.addEventListener('touchmove', stopSwipeOnNarrow, { capture: true, passive: true });
  sectionElement.dataset.tfxCollectionMobileClickPriorityBound = 'true';
};
/* END TFX_COLLECTION_RELATED_MOBILE_CLICK_PRIORITY_JS */

var tfxInitCollectionRelatedPresentation = function(sectionId) {
  if (!sectionId) { return; }
  var sectionElement = document.querySelector('[data-section-id="' + sectionId + '"][data-tfx-collection-section]');
  if (sectionElement === null) { return; }
  if (sectionElement.dataset.tfxCollectionRelatedPresentationEnabled !== 'true') { return; }

  tfxBindCollectionMobileClickPriority(sectionElement);
  tfxCollectionOverlayInit(sectionElement);
};

document.querySelectorAll('[data-tfx-collection-section]').forEach(function(sectionNode) {
  var initialSectionId = sectionNode.getAttribute('data-section-id');
  if (!initialSectionId) { return; }
  tfxInitCollectionRelatedPresentation(initialSectionId);
});

/* Editor events are centralized in assets/tfx-collection-overlay-refresh.js
   to avoid duplicate listener registration across section/script contexts. */
/* END TFX_COLLECTION_RELATED_PRESENTATION_JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-product-list"] && !Shopify.designMode) return;
  try {
    
/* BEGIN TFX_FC_DYNAMIC_RELATED_JS
   Objective: allow Product list (PDP) section to load Shopify dynamic product recommendations.
   Scope: sections/product-template-product-list.liquid (opt-in via section setting).
   Rollback: disable setting "TFX: Use dynamic related products" or remove this BEGIN/END block.
*/
(function() {
  if (window.__tfxFcDynamicRelatedBooted) { return; }
  window.__tfxFcDynamicRelatedBooted = true;

  var findDynamicSection = function(sectionId) {
    if (!sectionId) { return null; }
    return document.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-dynamic-related]');
  };

  var loadDynamicRecommendations = function(sectionElement, forceReload) {
    if (!sectionElement) { return; }
    if (sectionElement.getAttribute('data-tfx-fc-dynamic-related-enabled') !== 'true') { return; }
    if (!forceReload && sectionElement.dataset.tfxDynamicRelatedLoaded === 'true') { return; }
    if (sectionElement.dataset.tfxDynamicRelatedLoading === 'true') { return; }

    var requestUrl = sectionElement.getAttribute('data-tfx-fc-dynamic-related-url');
    if (!requestUrl) { return; }

    var targetContent = sectionElement.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!targetContent) { return; }

    sectionElement.dataset.tfxDynamicRelatedLoading = 'true';

    fetch(requestUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) { return ''; }
        return response.text();
      })
      .then(function(html) {
        if (!html) { return; }

        var container = document.createElement('div');
        container.innerHTML = html;

        var sectionId = sectionElement.getAttribute('data-section-id');
        var fetchedSection = null;
        if (sectionId) {
          fetchedSection = container.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-dynamic-related]');
        }
        if (!fetchedSection) {
          fetchedSection = container.querySelector('[data-tfx-fc-dynamic-related]');
        }
        if (!fetchedSection) { return; }

        var fetchedContent = fetchedSection.querySelector('[data-tfx-fc-dynamic-related-content]');
        if (!fetchedContent) { return; }

        targetContent.innerHTML = fetchedContent.innerHTML;
        sectionElement.dataset.tfxDynamicRelatedLoaded = 'true';

        if (sectionId && typeof window.tfxInitFeaturedCollectionPresentation === 'function') {
          window.tfxInitFeaturedCollectionPresentation(sectionId);
        }
      })
      .catch(function() {})
      .then(function() {
        sectionElement.dataset.tfxDynamicRelatedLoading = 'false';
      });
  };

  window.tfxInitFcDynamicRelatedSection = function(sectionId, forceReload) {
    var sectionElement = findDynamicSection(sectionId);
    loadDynamicRecommendations(sectionElement, !!forceReload);
  };

  document.querySelectorAll('[data-tfx-fc-dynamic-related]').forEach(function(sectionElement) {
    loadDynamicRecommendations(sectionElement, false);
  });

  if (!window.__tfxFcDynamicRelatedEditorEventsBound) {
    document.addEventListener('shopify:section:load', function(event) {
      if (!event.detail || !event.detail.sectionId) { return; }
      window.tfxInitFcDynamicRelatedSection(event.detail.sectionId, true);
    });

    document.addEventListener('shopify:section:select', function(event) {
      if (!event.detail || !event.detail.sectionId) { return; }
      window.tfxInitFcDynamicRelatedSection(event.detail.sectionId, false);
    });

    window.__tfxFcDynamicRelatedEditorEventsBound = true;
  }
})();
/* END TFX_FC_DYNAMIC_RELATED_JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
/* BEGIN TFX_RELATED_PRODUCTS_OVERLAY_ADD_JS
   Objective: add direct add-to-cart overlay action on related product cards only
   Scope: sections/related-products.liquid
   Rollback: remove this BEGIN/END block + related product-block hook
*/
var tfxRelatedProductsOverlayInit = function(productRecommendationsSection) {
  if (productRecommendationsSection === null) { return; }
  if (productRecommendationsSection.dataset.tfxOverlayInit === 'true') { return; }
  productRecommendationsSection.dataset.tfxOverlayInit = 'true';

  productRecommendationsSection.addEventListener('click', function(event) {
    var addButton = event.target.closest('[data-tfx-rp-add]');
    if (!addButton || !productRecommendationsSection.contains(addButton)) { return; }

    if (typeof window.tfxOverlayAddToCart !== 'function') {
      var productBlock = addButton.closest('.product-block');
      var productLink = productBlock ? productBlock.querySelector('.product-link[href]') : null;
      if (productLink) {
        window.location.href = productLink.getAttribute('href');
      }
      return;
    }

    event.preventDefault();
    window.tfxOverlayAddToCart(addButton);
  });
};

/* BEGIN TFX_RELATED_PRODUCTS_MOBILE_CLICK_PRIORITY_JS
   Objective: disable swipe image interactions on narrow viewports so mobile behavior stays click-first
   Scope: sections/related-products.liquid only
   Rollback: remove this BEGIN/END block (CSS block can stay)
*/
var tfxBindMobileClickPriority = function(productRecommendationsSection) {
  if (productRecommendationsSection === null) { return; }
  if (productRecommendationsSection.dataset.tfxMobileClickPriorityBound === 'true') { return; }
  var narrowViewportQuery = window.matchMedia('(max-width: 959.98px)');

  var stopSwipeOnNarrow = function(event) {
    if (!narrowViewportQuery.matches) { return; }
    var imageContainer = event.target.closest('.image-cont--with-secondary-image');
    if (!imageContainer || !productRecommendationsSection.contains(imageContainer)) { return; }
    event.stopPropagation();
  };
  productRecommendationsSection.addEventListener('touchstart', stopSwipeOnNarrow, true);
  productRecommendationsSection.addEventListener('touchmove', stopSwipeOnNarrow, true);
  productRecommendationsSection.dataset.tfxMobileClickPriorityBound = 'true';
};
/* END TFX_RELATED_PRODUCTS_MOBILE_CLICK_PRIORITY_JS */

var loadProductRecommendationsIntoSection = function(sectionElement) {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = sectionElement || document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  tfxBindMobileClickPriority(productRecommendationsSection);
  tfxRelatedProductsOverlayInit(productRecommendationsSection);
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var fetchedSection = container.querySelector(".related-products");
      if (fetchedSection) {
        productRecommendationsSection.innerHTML = fetchedSection.innerHTML;
      }
    }
  };
  request.send();
};
var tfxInitAndLoadAllRelatedProductsSections = function() {
  document.querySelectorAll(".related-products").forEach(function(productRecommendationsSection) {
    tfxBindMobileClickPriority(productRecommendationsSection);
    tfxRelatedProductsOverlayInit(productRecommendationsSection);
    loadProductRecommendationsIntoSection(productRecommendationsSection);
  });
};
// fetch when section reloads in editor
if (!window.__tfxRelatedProductsOverlayEditorEventsBound) {
  document.addEventListener("shopify:section:load", function(event) {
  var productRecommendationsSection = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products');
  if (productRecommendationsSection) {
    tfxBindMobileClickPriority(productRecommendationsSection);
    tfxRelatedProductsOverlayInit(productRecommendationsSection);
    loadProductRecommendationsIntoSection(productRecommendationsSection);
  }
  });
  document.addEventListener("shopify:section:select", function(event) {
  var productRecommendationsSection = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products');
  if (productRecommendationsSection) {
    tfxBindMobileClickPriority(productRecommendationsSection);
    tfxRelatedProductsOverlayInit(productRecommendationsSection);
  }
});
  window.__tfxRelatedProductsOverlayEditorEventsBound = true;
}
// Fetching the recommendations on page load
tfxInitAndLoadAllRelatedProductsSections();
/* END TFX_RELATED_PRODUCTS_OVERLAY_ADD_JS */

  } catch(e) { console.error(e); }
})();
})();
